export default __webpack_public_path__ + "static/media/icon-range.b7940177.svg";